module.exports = (Promise.resolve(__parcel__require__("./" + "Native.11e3f97e.74cd81e5.js"))).then(() => parcelRequire('2rsvV'));